/* eslint-disable operator-linebreak */
import React, { forwardRef, useCallback } from 'react';
import { NumberFormatBase } from 'react-number-format';
import { FormFeedback, FormGroup, Input, Label } from 'reactstrap';

/** Formata string de dígitos (centavos) como moeda BRL: 3825 -> "R$ 38,25" */
function formatCents(numStr) {
  const digits = String(numStr || '').replace(/\D/g, '');
  if (!digits) return '';
  const padded = digits.padStart(3, '0');
  const cents = padded.slice(-2);
  const intRaw = padded.slice(0, -2);
  const intPart = String(parseInt(intRaw, 10) || 0);
  const intFormatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `R$ ${intFormatted},${cents}`;
}

function removeFormatting(value) {
  return String(value || '').replace(/\D/g, '');
}

/** Converte valor do form (número ou string numérica) para string de centavos exibida internamente. */
function toCentsString(value) {
  if (value === null || value === undefined || value === '') return '';
  const num =
    typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'));
  if (Number.isNaN(num)) return '';
  return String(Math.round(num * 100));
}

function getCaretBoundary(formattedValue) {
  const len = formattedValue.length;
  return Array.from({ length: len + 1 }, (_, i) => i === len);
}

function MoneyMaskedInput({ label, value, invalidMessage, onValueChange, ...rest }, ref) {
  const handleValueChange = useCallback(
    (values, sourceInfo) => {
      if (!onValueChange) return;
      const digits = String(values.value || '').replace(/\D/g, '');
      let floatValue;
      if (!digits) {
        floatValue = undefined;
      } else {
        const intVal = parseInt(digits, 10);
        floatValue = Number.isNaN(intVal) ? undefined : intVal / 100;
      }
      const valueStr =
        floatValue === undefined ? '' : floatValue.toFixed(2);
      onValueChange(
        {
          formattedValue: values.formattedValue,
          value: valueStr,
          floatValue,
        },
        sourceInfo,
      );
    },
    [onValueChange],
  );

  return (
    <FormGroup>
      {label && <Label>{label}</Label>}
      <NumberFormatBase
        getInputRef={ref}
        customInput={Input}
        placeholder="Digite um valor"
        value={toCentsString(value)}
        valueIsNumericString
        format={formatCents}
        removeFormatting={removeFormatting}
        getCaretBoundary={getCaretBoundary}
        invalid={!!invalidMessage}
        onValueChange={handleValueChange}
        {...rest}
      />
      <FormFeedback>{invalidMessage}</FormFeedback>
    </FormGroup>
  );
}

export default forwardRef(MoneyMaskedInput);
